// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-decoration[data-v-158e68e4] {\n  text-decoration: none !important;\n  color: inherit !important;\n}\n.no-decoration[data-v-158e68e4]:visited,\n.no-decoration[data-v-158e68e4]:hover,\n.no-decoration[data-v-158e68e4]:active {\n  text-decoration: none !important;\n  color: inherit !important;\n}\n", ""]);
// Exports
module.exports = exports;
